import React from 'react';
import { renderNothing } from 'recompose';

const StakeholdersUploadStatus = ({
  changeImpact,
  project,
  onDownloadErrorsCsv,
}) => {
  return changeImpact.stakeholderStructureErrors ? (
    <div className="component-xl component-xl component-bg-white component-border-bottom text-center">
      <h3 className="text-danger">
        There was an issue with the Stakeholders CSV.
      </h3>
      <br />
      <br />

      {project.manageProjectEntities ? (
        <p className="no-margin">
          Please download the CSV error report
          <button
            type="button"
            className="btn-link"
            onClick={onDownloadErrorsCsv}
          >
            here
          </button>
        </p>
      ) : null}
    </div>
  ) : (
    renderNothing
  );
};

export default StakeholdersUploadStatus;
